export default __webpack_public_path__ + "static/media/thermometer_v3.d07126e9.svg";